module.exports = __webpack_public_path__ + "img/taetigkeiten.4369c5e3.png";